import type { PluggableAccountFunctions } from '../types/PluggableAccountFunctions';

export function initializePluggableAccountFunctions(functions: PluggableAccountFunctions): void {
    pluggableAccountFunctions = {
        ...(pluggableAccountFunctions ?? {}),
        ...functions,
    };
}

export let pluggableAccountFunctions: PluggableAccountFunctions | undefined = undefined;
